<template>
  <div class="u-bottom">
    <div class="unit-image" />
    <p>地址: 北京市海淀区万寿路27号院 工业和信息化部 邮编：100846</p>
    <p>主办单位: 中国共产党工业和信息化部人才交流中心委员会  京ICP备 07500136号</p>
    <p class="safe-record">
      <span>京公网安备 11010802027711号</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Bottom'
}
</script>

<style lang="scss" scoped>
  .u-bottom{
    width: 100%;
    min-width: 1200px;
    height: 210px;
    text-align: center;
    line-height: 30px;
    border-top: 20px solid #9b181e;
    color: #999;
    .unit-image{
      width: 100%;
      height: 100px;
      background: url('../../assets/images/bottom_institution_icon.png') center center no-repeat;
    }
    p{
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: center;
    }
    .safe-record{
      margin-top:10px;
      span{
        padding-left: 24px;
        background: url('../../assets/images/home_badge.png') left center no-repeat;
      }
    }
  }
</style>
